import * as Sentry from "@sentry/react";

import { unregisterPushNotifications, useSessionUser } from "@web-app/api";
import config from "@web-app/config";
import useDispatchStore from "@web-app/store/dispatchStore";
import { todaysStartDateString } from "@web-app/utils/helpers";

export default function useApp() {
  const { data: sessionUser, isLoading, isError } = useSessionUser();

  if (sessionUser) {
    useDispatchStore.setState({
      user: sessionUser,
    });

    // Set user context in Sentry when user is logged in
    if (config.APP_ENV === "production") {
      Sentry.setUser({
        email: sessionUser.email,
        id: sessionUser.id,
        name: sessionUser.name,
        workspace: sessionUser.currentWorkspace?.name,
      });

      // Add a tag for the user's role
      Sentry.setTag("user_role", sessionUser.role.role);

      // Add a breadcrumb for login
      Sentry.addBreadcrumb({
        category: "auth",
        level: "info",
        message: `User ${sessionUser.name} logged in`,
      });
    }
  }

  if (window.location.pathname === "/signin") {
    if (sessionUser) {
      window.location.href = "/";
    }
  } else {
    if (isError || sessionUser?.role.role === "DRIVER") {
      // Clear user context in Sentry when user is logged out
      if (config.APP_ENV === "production") {
        Sentry.setUser(null);
      }

      localStorage.removeItem(config.API_TOKEN);
      window.location.href = "/signin";
    }
  }

  const logout = () => {
    unregisterPushNotifications();

    useDispatchStore.setState({
      dateUpdateAt: todaysStartDateString,
    });

    // Clear user context in Sentry when user logs out
    if (config.APP_ENV === "production" && sessionUser) {
      Sentry.setUser(null);

      // Add a breadcrumb for logout
      Sentry.addBreadcrumb({
        category: "auth",
        level: "info",
        message: `User ${sessionUser.name} logged out`,
      });
    }

    localStorage.removeItem(config.API_TOKEN);
    window.location.href = "/signin";
  };
  return { isLoading, logout, sessionUser };
}
